<template>
    <b-modal ref="worklog-modal"
             size="lg"
             :title="show_task_key ? trans('tasks.actions.log_work_for_task', {task: task_id}) : trans('tasks.actions.log_work')"
             no-close-on-backdrop
             no-close-on-esc
             hide-header-close>
        <template #default>
            <form v-debounce ref="form">
                <work-log-form ref="workLogForm"
                               :input-errors="messages.validation"
                               :worklog="worklog"
                               :allowPartialCharge="task.project.allow_partial_charge"
                               :remaining-work="remainingWork"
                               :logged-time-preset="loggedTimePreset"
                               @needToReschedule="needToReschedule"
                               @isLoading="isLoading = $event"
                >
                </work-log-form>
            </form>
        </template>
        <template #modal-footer class="text-right">
            <button :disabled="isLoading"
                    type="submit"
                    class="btn btn-success"
                    @click="checkForReschedule"
            >{{ trans('common.actions.save') }}</button>

            <button v-if="userCan('projects.tasks.reestimate_on_work_log')"
                    :disabled="isLoading"
                    type="submit"
                    class="btn btn-primary"
                    @click="submit(true)"
            >{{ trans('tasks.actions.save_and_reestimate') }}</button>

            <button type="button"
                    class="btn btn-light"
                    @click="cancel"
            >{{ trans('common.actions.cancel') }}</button>
        </template>
    </b-modal>
</template>

<script>

    import {mapState, mapActions} from 'vuex';

    import WorkLogForm from '@/views/Tasks/WorkLog/Partials/Form';

    import TaskWorkLogController from '@/services/Tasks/TaskWorkLogController';

    export default {

        props: ['task_id', 'task', 'show_task_key', 'worklog', 'remainingWork', 'loggedTimePreset', 'completeTaskWorkTimer'],

        components: {WorkLogForm},

        data() {
            return {
                additionalTime: false,
                isLoading: false,
            };
        },

        mounted() {
            this.resetMessages();
            this.showModal();
        },

        computed: {

            ...mapState(['messages'])

        },

        methods: {

            ...mapActions(['resetMessages', 'swalToast']),

            checkForReschedule() {
                if (this.additionalTime && this.userCan('projects.tasks.reestimate_on_work_log')) {
                    this.$swal({
                        title: this.trans('projects.status_actions.reestimate_required'),
                        text: this.trans('projects.status_actions.work_remaining_limit_reached'),
                        type: 'warning',
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        showCancelButton: true,
                        cancelButtonText: this.trans('projects.status_actions.reestimate'),
                        cancelButtonColor: '#007bff',
                        confirmButtonColor: '#d33',
                        confirmButtonText: this.trans('projects.status_actions.im_sure'),
                    }).then((result) => {
                        if (result.value) {
                            this.submit();
                        } else if (result.dismiss) {
                            this.submit(true);
                        }
                    });
                } else {
                    this.submit();
                }
            },

            submit(doReschedule = false) {
                this.formSubmitShowWait(this.$refs.form);

                const worklog = this.$refs.workLogForm.getModel();
                const request = this.worklog && this.worklog.exists
                    ? TaskWorkLogController.update(this.worklog.secret_key, worklog)
                    : TaskWorkLogController.store(this.task_id, worklog);

                request.then(() => {
                    this.resetMessages();
                    if (this.completeTaskWorkTimer) {
                        this.$emit('completetimer');
                    }

                    if (doReschedule) {
                        this.$emit('reschedule', this.additionalTime);
                    } else {
                        this.$emit('saved');
                    }

                    this.hideModal();
                }).catch(() => {
                    // nothing to do
                }).finally(() => {
                    this.formSubmitHideWait(this.$refs.form);
                });
            },

            cancel() {
                this.$emit('cancel');
                this.hideModal();
            },

            showModal() {
                this.$refs['worklog-modal'].show();
                this.$emit('shown');
            },

            hideModal() {
                this.$refs['worklog-modal'].hide();
                this.$emit('hidden');
            },

            needToReschedule(response) {
                if (response.isRescheduelRequired) {
                    this.additionalTime = response.additionalTime;
                }
            },

        }

    };

</script>



// WEBPACK FOOTER //
// src/views/Tasks/Task/Partials/Show/WorkLogModal.vue